import { useEffect, useState } from 'react';
import api from './api';

// GET /features nie wymaga logowania. Gdy backend nie odpowie (np. starsza wersja
// bez /features), moduł fakturowania traktujemy jako wyłączony.
const FEATURES_UNKNOWN = { configured: true, invoicing: false };

let featuresRequest = null;

const fetchFeatures = () => {
    if (!featuresRequest) {
        featuresRequest = api.get('/features')
            .then((response) => response.data)
            .catch((error) => {
                console.error('Failed to fetch features', error);
                featuresRequest = null;
                return FEATURES_UNKNOWN;
            });
    }
    return featuresRequest;
};

// Zwraca null do czasu odpowiedzi backendu, potem { configured, invoicing }
export const useFeatures = () => {
    const [features, setFeatures] = useState(null);

    useEffect(() => {
        let active = true;
        fetchFeatures().then((result) => {
            if (active) setFeatures(result);
        });
        return () => {
            active = false;
        };
    }, []);

    return features;
};
